import React from "react";
import useSaveButton from "../../../../../hooks/useSaveButton";
import { useUscLabel } from "../../../../../utils/labels";
import Checkbox from "../../../../../../shared-components/toyota/styles/atoms/Checkbox";
import Icon from "../../../../../../shared-components/toyota/styles/atoms/Icon";
import { trackCta, UscTrackingLocation } from "../../../../../utils/tracking";
import { useUscSelector } from "../../../../../redux/store";

const SaveButton = ({ trackingLocation }: { trackingLocation: UscTrackingLocation }): JSX.Element | null => {
    const { isSaved, saveClick } = useSaveButton();
    const saveCarLabel = useUscLabel("uscA11yButtonSaveCar");
    const modelName = useUscSelector((state) => state.vehicle.result?.product.model);
    const vehicleType = useUscSelector((state) => state.vehicle.type);

    return (
        <Checkbox
            variant="favourite"
            // Edge case: Tracking location is used for making sure all save buttons have different ids
            id={`${trackingLocation === UscTrackingLocation.Basket ? "basket-" : ""}favourite`}
            title={saveCarLabel}
            checked={isSaved}
            onClick={() => {
                if (!isSaved) trackCta(`add-favourite-${modelName || ""}`, trackingLocation, vehicleType);
                saveClick();
            }}
        >
            {isSaved ? <Icon variant="heart-filled" /> : <Icon variant="heart" />}
        </Checkbox>
    );
};

export default SaveButton;
